import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavLink,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { NavLink as Link } from "react-router-dom";
import Logo from "./Logo";
import "./Header.css";
import { FaSignOutAlt } from "react-icons/fa";
import * as authActions from "../../actions/auth";
import { Loading } from "../../loader/Loading";
import { hasPrivilege } from "../../Components/Utils/utils";
import { menu_privileges } from "../Constants/static";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false),
    [logout, setLogout] = useState(false),
    { token } = useSelector((state) => state.auth),
    { superAdmin } = useSelector((state) => state.account),
    { userPool, userPoolRoles } = useSelector((state) => state.pool),
    dispatch = useDispatch();
  return (
    <Navbar color="dark" dark expand="md" className="py-0">
      <Logo />
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
      {logout && <Loading />}
      <Collapse isOpen={isOpen} navbar>
        {token && (
          <Nav
            className="mr-auto"
            navbar
            center="true"
            style={{ padding: "0% 0% 0% 30%", marginTop: "1.5%" }}
          >
            {userPool &&
              hasPrivilege(
                userPoolRoles,
                menu_privileges["create"].concat(
                  menu_privileges["modify"],
                  menu_privileges["view"],
                  menu_privileges["reset"],
                  menu_privileges["generateReport"]
                ),
                superAdmin
              ) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Manage Users
                  </DropdownToggle>
                  <DropdownMenu center={"true"}>
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["create"],
                      superAdmin
                    ) && (
                      <NavLink to="/create" tag={Link}>
                        <DropdownItem>Create User</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["view"],
                      superAdmin
                    ) && (
                      <NavLink to="/view" tag={Link}>
                        <DropdownItem>View User</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["modify"],
                      superAdmin
                    ) && (
                      <NavLink to="/modify" tag={Link}>
                        <DropdownItem>Modify User</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["reset"],
                      superAdmin
                    ) && (
                      <NavLink to="/reset" tag={Link}>
                        <DropdownItem>Reset Password</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["generateReport"],
                      superAdmin
                    ) && (
                      <NavLink to="/report" tag={Link}>
                        <DropdownItem>Generate Report</DropdownItem>
                      </NavLink>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            {userPool &&
              hasPrivilege(
                userPoolRoles,
                menu_privileges["review"].concat(menu_privileges["reapprove"]),
                superAdmin
              ) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Review Users
                  </DropdownToggle>
                  <DropdownMenu>
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["review"],
                      superAdmin
                    ) && (
                      <NavLink to="/review" tag={Link}>
                        <DropdownItem>Review Request</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["reapprove"],
                      superAdmin
                    ) && (
                      <NavLink to="/rejectedlist" tag={Link}>
                        <DropdownItem>Rejection History</DropdownItem>
                      </NavLink>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            {((superAdmin && !userPool) || (userPool && !superAdmin)) &&
              hasPrivilege(
                userPoolRoles,
                menu_privileges["manageAdmin"],
                superAdmin
              ) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Manage Admin
                  </DropdownToggle>
                  <DropdownMenu>
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["manageAdmin"],
                      superAdmin
                    ) && (
                      <NavLink to="/createadmin" tag={Link}>
                        <DropdownItem>Create Admin</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["manageAdmin"],
                      superAdmin
                    ) && (
                      <NavLink to="/viewadmin" tag={Link}>
                        <DropdownItem>View Admin</DropdownItem>
                      </NavLink>
                    )}
                    {hasPrivilege(
                      userPoolRoles,
                      menu_privileges["manageAdmin"],
                      superAdmin
                    ) && (
                      <NavLink to="/modifyadmin" tag={Link}>
                        <DropdownItem>Modify Admin</DropdownItem>
                      </NavLink>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
          </Nav>
        )}
        {token && (
          <Nav
            className="ml-auto logout on-hover-logout on-hover-cursor"
            navbar
            onClick={() => {
              dispatch(authActions.logout());
              setLogout(true);
            }}
          >
            <div>
              Logout &nbsp;
              <FaSignOutAlt size={"1.5em"} />
            </div>
          </Nav>
        )}
      </Collapse>
    </Navbar>
  );
};

export default Header;
